import {Typography} from '@mui/material';
import React, {ReactNode} from 'react';
import {SxProps, Theme} from '@mui/material/styles';

interface Props {
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

const PageSubtitle: React.FC<Props> = ({children, sx}) => {
  return (
    <Typography sx={{mt: 2, mb: 2, ...sx}} variant="h2">
      {children}
    </Typography>
  );
};

export default PageSubtitle;
